import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FiSave, FiX } from 'react-icons/fi';
import Api from '../../Api';
import Modal from '../Modal';
import Button from '../Button';
import Input from '../Input';
import Select from '../Select';
import '../CompanyForm/style.css';

export default function EmployeeBankDataModal({
  isOpen,
  onClose,
  companyId,
  employee,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    bank_name: '',
    bank_agency: '',
    bank_account: '',
    bank_account_type: '',
    has_pix: 'false',
    pix_key_type: '',
    pix_key: '',
  });

  useEffect(() => {
    if (isOpen && employee) {
      setFormData({
        bank_name: employee.bank_name || '',
        bank_agency: employee.bank_agency || '',
        bank_account: employee.bank_account || '',
        bank_account_type: employee.bank_account_type || '',
        has_pix: employee.has_pix ? 'true' : 'false',
        pix_key_type: employee.pix_key_type || '',
        pix_key: employee.pix_key || '',
      });
    }
  }, [isOpen, employee]);

  function handleChange(e) {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      await Api.put(
        `/companies/${companyId}/employees/${employee.id}/bank-data`,
        formData
      );
      toast.success('Dados bancários atualizados com sucesso!');
      onSuccess();
      onClose();
    } catch (error) {
      const message =
        error.response?.data?.error || 'Erro ao atualizar dados bancários.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Dados Bancários - ${employee?.name}`}
    >
      <form onSubmit={handleSubmit} className="company-form-component">
        <div className="form-body">
          <div className="form-grid">
            <Input
              id="bank_name"
              label="Banco"
              value={formData.bank_name}
              onChange={handleChange}
            />

            <Input
              id="bank_agency"
              label="Agência"
              value={formData.bank_agency}
              onChange={handleChange}
            />

            <Input
              id="bank_account"
              label="Conta"
              value={formData.bank_account}
              onChange={handleChange}
            />

            <Select
              id="bank_account_type"
              label="Tipo de Conta"
              value={formData.bank_account_type}
              onChange={handleChange}
              options={[
                { value: '', label: 'SELECIONE...' },
                { value: 'Corrente', label: 'Corrente' },
                { value: 'Poupança', label: 'Poupança' },
                { value: 'Salário', label: 'Salário' }
              ]}
            />

            <Select
              id="has_pix"
              label="Possui PIX?"
              value={formData.has_pix}
              onChange={handleChange}
              options={[
                { value: 'false', label: 'Não' },
                { value: 'true', label: 'Sim' }
              ]}
            />

            {formData.has_pix === 'true' && (
              <>
                <Select
                  id="pix_key_type"
                  label="Tipo de Chave PIX"
                  value={formData.pix_key_type}
                  onChange={handleChange}
                  options={[
                    { value: '', label: 'SELECIONE...' },
                    { value: 'CPF', label: 'CPF' },
                    { value: 'CNPJ', label: 'CNPJ' },
                    { value: 'Email', label: 'Email' },
                    { value: 'Telefone', label: 'Telefone' },
                    { value: 'Aleatoria', label: 'Aleatória' }
                  ]}
                />

                <Input
                  id="pix_key"
                  label="Chave PIX"
                  value={formData.pix_key}
                  onChange={handleChange}
                />
              </>
            )}
          </div>
        </div>

        <div className="form-actions">
          <Button
            type="button"
            className="cancel-button"
            onClick={onClose}
            disabled={loading}
          >
            <FiX /> Cancelar
          </Button>
          <Button type="submit" disabled={loading}>
            <FiSave /> Salvar
          </Button>
        </div>
      </form>
    </Modal>
  );
}
